module.exports = __webpack_public_path__ + "static/media/geometry@2x.eb99f2a2.png";